import { render, staticRenderFns } from "./Salvage.vue?vue&type=template&id=16115cf6"
import script from "./Salvage.vue?vue&type=script&lang=js"
export * from "./Salvage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports